import { useSelect } from '~/store'
import { selUserConnectionStatus } from '~/features/user-state/user-state-module'
import { OrganizationSettingsScaffold } from './st-organization-settings-scaffold'

export function OrganizationDesktopAgentPage() {
  const connectionStatus = useSelect('userState', selUserConnectionStatus)
  const connected = connectionStatus == 'connected'

  return (
    <OrganizationSettingsScaffold title="Settings">
      <h2 className="text-xl text-gray-800">Desktop agent</h2>

      <div className="mt-5 flex flex-col items-start gap-2">
        <p>Status</p>
        <span
          className={
            connected
              ? 'inline-flex items-center gap-1.5 rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-700'
              : 'inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-2 py-1 text-xs font-medium text-gray-600'
          }
        >
          <span
            className={
              connected
                ? 'size-1.5 rounded-full bg-green-500'
                : 'size-1.5 rounded-full bg-gray-400'
            }
          />
          {connectionStatus}
        </span>
      </div>
    </OrganizationSettingsScaffold>
  )
}
